import React from 'react'
import trash from 'D:/Projects/FoodApp/frontend-food-app/src/icons8-trash.svg'
import { useDispatchCart, useCart } from '../components/ContextReducer';

export default function Cart()
{
    let data = useCart();
    let dispatch = useDispatchCart();
    if(data.length === 0)
    {
        return (
            <div>
                <div className='m-5 w-100 text-center fs-3'>The Cart is Empty!</div>
            </div>
        )
    }

    const handleCheckOut = async () => {
        let userEmail = localStorage.getItem("userEmail");
        // console.log(data,localStorage.getItem("userEmail"),new Date())
        let response = await fetch("https://foodapp-api-u4lc.onrender.com/api/orderdata", {
          // credentials: 'include',
          // Origin:"http://localhost:3000/login",
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            order_data: data,
            email: userEmail,
            order_date: new Date().toDateString()
          })
        });
        console.log("JSON RESPONSE:::::", response.status)
        if (response.status === 200) {
          dispatch({ type: "DROP" })
        }
      }

    let totalPrice = data.reduce((total, food) => total + food.Price, 0)
    
    
  return (
    <div>
        {console.log(data)}    
        <div className='container m-auto mt-5 table-responsive table-responsive-sm table-responsive-md'>
            <table className='table table-hover'>
                <thead className='text-success fs-4'>
                    <tr>
                        <th scope='col'>#</th>
                        <th scope='col'>Name</th>
                        <th scope='col'>Quantity</th>
                        <th scope='col'>Option</th>
                        <th scope='col'>Amount</th>
                        {/* <th scope='col'>#</th> */}
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map((food, index) => (
                            <tr>
                                <td scope='row'>{index + 1}</td>
                                <td>{food.name}</td>
                                <td>{food.qty}</td>
                                <td>{food.size}</td>
                                <td>{food.Price}</td>
                                <button type='button' className='btn p-0'><img src={trash} alt='delete' onClick={() => {dispatch({type: "REMOVE", index: index})}}/> </button>        
                            </tr>

                        ))
                    }
                </tbody>    
            </table>      
            <div><h1 className='fs-2'>TotalPrice : {totalPrice}/-</h1> </div>
            <div>
                <button className='btn bg-success mt-5' onClick={handleCheckOut}>Check Out</button>
            </div>      
        </div>
      
    </div>
  )
}
